module.exports = __webpack_public_path__ + "static/media/vote-award-title.7cd20866.svg";